import React from 'react';
import { FaPencilAlt, FaTrash, FaRupeeSign, FaCalendar, FaCreditCard, FaCheckCircle, FaClock, FaTimesCircle, FaEnvelope } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';
import { Table, Card, Badge, ProgressBar } from 'react-bootstrap';

import SalesOrderAPI from '../../api/SalesOrderAPI';
import Const from '../../util/Constants';
import Util from '../../util/Util';
import Display from '../../util/Display';

class SaleInstallmentList extends React.Component {

  constructor(props) {
    super(props);
    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.installment;
    this.EmailAdd = Util.isAllow(this.models.email.permission, Const.PermAdd);

    this.keys = [];
    const keys = Object.keys(this.model.fields);
    for (let i = 0; i < keys.length; i++) {
      if (keys[i] !== 'id' && keys[i] !== 'status' && keys[i] !== 'sales_order_id' && keys[i] !== 'model'
        && keys[i] !== 'created_by' && keys[i] !== 'updated_by'
        && keys[i] !== 'created_date' && keys[i] !== 'updated_date'
        && this.model.fields[keys[i]].status !== Const.Trash) {
        this.keys.push(keys[i]);
      }
    }
    this.keys = this.keys.sort((field1, field2) =>
      this.model.fields[field1].field_order - this.model.fields[field2].field_order);

    const sale = this.props.sale;
    this.salesId = sale.id;

    this.installments = [];
    this.installment = {
      id: 0, model_no: sale.model_no, model_id: sale.model_id,
      sales_order_id: sale.id, installment_date: Util.dateToServerDateTime(new Date()),
      amount: 0, mode: 0, account: 0, installment_status: 0, comment: ''
    };

    this.state = { inApiCall: true, inValid: {}, installment: {}, popup: false };

    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
  }

  componentDidMount() {
    SalesOrderAPI.getInstallmentInnerList(this.salesId, this.onReceived, this.onFail);
  }

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = res => {
    this.installments = res.data;
    this.setState({ ...this.state, inApiCall: false });
  };

  delete = index => {
    Util.confirmAlert('Delete', 'Are you sure you want to delete', 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      SalesOrderAPI.deleteInstallment(this.installments[index].id, this.onDelete, this.onFail);
    });
  };
  onDelete = () => {
    Util.showNotification('Successful', 'Installment Deleted successfully', 'success');
    this.props.reload();
  };

  formatCurrency = (amount) => {
    if (!amount) return '₹0';
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(amount);
  };

  getStatusBadge = (status) => {
    const statusConfig = {
      1: { variant: 'success', icon: FaCheckCircle, label: 'Paid' },
      2: { variant: 'warning', icon: FaClock, label: 'Pending' },
      3: { variant: 'danger', icon: FaTimesCircle, label: 'Overdue' },
      0: { variant: 'secondary', icon: FaClock, label: 'Not Paid' }
    };

    const config = statusConfig[status] || statusConfig[0];
    const IconComponent = config.icon;

    return (
      <Badge 
        bg={config.variant} 
        style={{ 
          fontSize: '12px', 
          padding: '6px 12px',
          borderRadius: '20px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          fontWeight: '500'
        }}
      >
        <IconComponent style={{ fontSize: '10px' }} />
        {config.label}
      </Badge>
    );
  };

  calculateProgress = () => {
    if (!this.installments.length) return 0;
    
    const totalAmount = this.installments.reduce((sum, inst) => sum + (parseFloat(inst.amount) || 0), 0);
    const paidAmount = this.installments
      .filter(inst => inst.installment_status === 1)
      .reduce((sum, inst) => sum + (parseFloat(inst.amount) || 0), 0);
    
    return totalAmount > 0 ? (paidAmount / totalAmount) * 100 : 0;
  };

  // Design 1 - Original simple design
  renderDesign1() {
    let installments = this.installments.map((installment, i) =>
      <tr key={`installment_${i}`}>
        {this.keys.map((key, j) =>
          <td key={`${key}_${j}`}>{Display.FieldValue(installment, key, this.model.fields)}</td>)
        }
        <td>
          {this.Update &&
            <span className="buttons update" onClick={() => this.props.edit(installment, Const.Installment)}>
              <FaPencilAlt /> Edit
            </span>
          }
          {this.Delete &&
            <span className="buttons delete" onClick={() => this.delete(i)}>
              <FaTrash /> Delete
            </span>
          }
          {this.EmailAdd &&
            <span className="buttons info" onClick={() => this.props.edit(installment, Const.Email)}>
              <FaEnvelope /> Email 
            </span>
          }
        </td>
      </tr>
    );
    if (installments.length === 0) installments = <tr><td colSpan="7">No Records Found</td></tr>;  
    return (
      <div className="installemtsDiv">
        <div className="row pt-4"><div className="col-md-6"><h3>Installments</h3></div></div>
        <div className="row pt-4 pb-4">
          <div className="col-md-12">
            <Table striped bordered hover>
              <thead>
                <tr>
                  {this.keys.map(key => <th key={key}>{this.model.fields[key].label_name}</th>)}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>{installments}</tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  }

  // Design 2 - Premium modern design
  renderDesign2() {
    const progress = this.calculateProgress();
    const totalInstallments = this.installments.length;
    const paidInstallments = this.installments.filter(inst => inst.installment_status === 1).length;

    let installments = this.installments.map((installment, i) =>
      <tr key={`installment_${i}`} style={{ borderBottom: '1px solid #f1f5f9' }}>
        {this.keys.map((key, j) => {
          if (key === 'installment_status') {
            return (
              <td key={`${key}_${j}`} style={{ padding: '16px 12px', verticalAlign: 'middle' }}>
                {this.getStatusBadge(installment[key])}
              </td>
            );
          } else if (key === 'amount') {
            return (
              <td key={`${key}_${j}`} style={{ padding: '16px 12px', verticalAlign: 'middle' }}>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '6px',
                  fontWeight: '600',
                  color: '#059669'
                }}>
                  <FaRupeeSign style={{ fontSize: '12px', opacity: 0.7 }} />
                  {this.formatCurrency(installment[key])}
                </div>
              </td>
            );
          } else if (key === 'installment_date') {
            return (
              <td key={`${key}_${j}`} style={{ padding: '16px 12px', verticalAlign: 'middle' }}>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '6px',
                  color: '#475569'
                }}>
                  <FaCalendar style={{ fontSize: '12px', opacity: 0.7 }} />
                  {Display.FieldValue(installment, key, this.model.fields)}
                </div>
              </td>
            );
          } else {
            return (
              <td key={`${key}_${j}`} style={{ padding: '16px 12px', verticalAlign: 'middle' }}>
                {Display.FieldValue(installment, key, this.model.fields)}
              </td>
            );
          }
        })}
        <td style={{ padding: '16px 12px', verticalAlign: 'middle' }}>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            {this.Update &&
              <button
                onClick={() => this.props.edit(installment, Const.Installment)}
                style={{
                  background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '8px 12px',
                  color: 'white',
                  fontSize: '12px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 8px rgba(245, 158, 11, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                <FaPencilAlt style={{ fontSize: '10px' }} /> Edit
              </button>
            }
            {this.Delete &&
              <button
                onClick={() => this.delete(i)}
                style={{
                  background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '8px 12px',
                  color: 'white',
                  fontSize: '12px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 8px rgba(220, 38, 38, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                <FaTrash style={{ fontSize: '10px' }} /> Delete
              </button>
            }

            {this.EmailAdd && (
              <button
                onClick={() =>
                  this.props.edit(installment, Const.Email)
                }
                style={{
                  background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '8px 12px',
                  color: 'white',
                  fontSize: '12px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow =
                    '0 4px 8px rgba(37, 99, 235, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <FaEnvelope style={{ fontSize: '10px' }} />
                Email
              </button>
            )}
          </div>
        </td>
      </tr>
    );
    
    if (installments.length === 0) {
      installments = (
        <tr>
          <td colSpan={this.keys.length + 1} style={{ 
            padding: '40px 20px', 
            textAlign: 'center',
            color: '#64748b',
            fontSize: '14px'
          }}>
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center',
              gap: '12px'
            }}>
              <FaCreditCard style={{ fontSize: '32px', opacity: 0.5 }} />
              <div>
                <div style={{ fontWeight: '600', marginBottom: '4px' }}>No Installments Found</div>
                <div style={{ fontSize: '13px' }}>Add your first installment to get started</div>
              </div>
            </div>
          </td>
        </tr>
      );
    }

    return (
      <Card
        style={{
          border: "none",
          borderRadius: "20px",
          boxShadow: "0 10px 25px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)",
          marginBottom: "24px",
          background: "white",
          overflow: "hidden"
        }}
      >
        <Card.Header
          style={{
            backgroundColor: "transparent",
            borderBottom: "1px solid #f1f5f9",
            padding: "24px 28px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <div
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "12px",
                backgroundColor: "#e0f2fe",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <FaCreditCard style={{ color: "#0284c7", fontSize: "20px" }} />
            </div>
            <div>
              <h5 style={{ 
                margin: 0, 
                fontWeight: 600, 
                color: "#0f172a", 
                fontSize: "18px",
                marginBottom: "4px"
              }}>
                Payment Installments
              </h5>
              <p style={{ 
                margin: 0, 
                fontSize: "14px", 
                color: "#64748b" 
              }}>
                {totalInstallments} installments • {paidInstallments} paid
              </p>
            </div>
          </div>
        </Card.Header>

        <Card.Body style={{ padding: "0" }}>
          {/* Installments Table */}
          <div style={{ overflowX: 'auto' }}>
            <Table 
              borderless 
              style={{ 
                margin: 0,
                width: '100%'
              }}
            >
              <thead>
                <tr style={{ 
                  backgroundColor: "#f8fafc",
                  borderBottom: "2px solid #e2e8f0"
                }}>
                  {this.keys.map(key => (
                    <th 
                      key={key} 
                      style={{ 
                        padding: "16px 12px",
                        fontWeight: "600",
                        color: "#475569",
                        fontSize: "13px",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        border: "none"
                      }}
                    >
                      {this.model.fields[key].label_name}
                    </th>
                  ))}
                  <th 
                    style={{ 
                      padding: "16px 12px",
                      fontWeight: "600",
                      color: "#475569",
                      fontSize: "13px",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      border: "none",
                      textAlign: 'center'
                    }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>{installments}</tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>
    );
  }

  render() {
    // Get design view from props or localStorage
    const designView = this.props.designView || reactLocalStorage.get("booking_design") || "2";
    
    // Render based on design view
    if (designView === "1") {
      return this.renderDesign1();
    } else {
      return this.renderDesign2();
    }
  }
}

export default SaleInstallmentList;